<template>
  <div class="header-wrapper-inner">
    <div class="header-left-wrapper">
      <i class="el-icon-s-fold menu-switch" @click="toggleMenu" v-if="app.device === 'mobile'"></i>
      <breadcrumb></breadcrumb>
    </div>
    <div class="header-right-wrapper">
      <!-- 公告通知 -->
      <notice></notice>
      <!-- 下载通知 -->
      <download></download>
      <!-- 国际化 -->
      <lang></lang>
      <!-- 用户信息 -->
      <template v-if="app.device !== 'mobile'">
        <el-dropdown>
          <span class="el-dropdown-link">
            <span class="i-dropdown-text">{{ app.userLogin.operatorEmail }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template slot="dropdown">
            <el-dropdown-menu>
              <!-- <router-link @click="updatePassword" to="/account/password/edit">
                <el-dropdown-item>{{ $t('message.user.updatePassword') }}</el-dropdown-item>
              </router-link> -->
              <div v-if="!app.userLogin.isManage" @click="updatePassword">
                <el-dropdown-item>
                  <div>{{ $t('message.user.updatePassword') }}</div>
                </el-dropdown-item>
              </div>
              <div @click="logout">
                <el-dropdown-item>
                  <div>{{ $t('message.user.logout') }}</div>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { doLogout } from '@/api/common/user';
import Breadcrumb from '@/components/breadcrumb/breadcrumb';
import Download from '@/components/download/index.vue';
import Lang from '@/components/lang/index.vue';
import Notice from '@/layout/base/components/iheader/notice.vue';
import { removeLocalStorage } from '@/utils/tools/utils';

export default {
  name: 'IHeader',
  components: { Lang, Breadcrumb, Download, Notice },
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
    };
  },
  methods: {
    toggleMenu() {
      if (this.$props.isCollapse) {
        this.$emit('closeNavbar');
        return;
      }
      this.$emit('openNavbar');
    },
     logout() {
      const loading = this.$loading();
      doLogout().then(async () => {
        removeLocalStorage('userLogin');
        removeLocalStorage('BusinessTypes');
        await this.$store.dispatch('app/setBusinessTypes', null);
        window.location.href = '/user/login';
      }).catch(() => {
        loading.close();
      });
    },
    updatePassword() {
      this.$router.push({
        path: '/account/password/edit',
        query: {
          from: this.$route.path,
        },
      });
    },
  },
};
</script>
<style lang="scss">
@import '~@/styles/variables.scss';

.header-wrapper-inner {
  background-color: $color-bg;
  // padding-bottom: 15px;
  box-sizing: border-box;

  span {
    color: $color-text-primary-new;
  }

  .el-dropdown-link {
    cursor: pointer;
  }
}
</style>
